import { StackProps, Switch, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { StyledColumn } from '../../style';

const ToggleColumn: FunctionComponent<
  Omit<StackProps, 'sx' | 'alignItems' | 'justifyContent' | 'flexDirection' | 'onClick'> & {
    onToggle: (name: string, value: boolean) => void;
    name: string;
    label: string;
    enabled: boolean;
    testId?: string;
    disabled?: boolean;
  }
> = ({ enabled, label, testId, name, onToggle, disabled, ...props }) => {
  const disabledClass = !enabled ? { backgroundColor: '#F4F4F7' } : {};
  return (
    <StyledColumn
      sx={{
        cursor: disabled ? 'default' : 'pointer',
        paddingInline: '16px',
        paddingBlock: '9px',
        width: '100%',
        ...disabledClass,
      }}
      alignItems="center"
      flexDirection="row"
      justifyContent="space-between"
      onClick={disabled ? undefined : () => onToggle(name, !enabled)}
      {...props}
    >
      <Typography
        noWrap
        fontWeight="600"
        variant="body2"
        color={!enabled ? '#8998A0' : 'primary'}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '100%',
        }}
      >
        {label}
      </Typography>
      <Switch
        inputProps={{ 'data-sm': testId } as any}
        size="small"
        checked={!!enabled}
        disabled={disabled}
      />
    </StyledColumn>
  );
};

export default ToggleColumn;
